
<template>
  <v-form ref="form" :readonly="readonly">
    <v-row>
      <v-col cols="12" md="12">
        <v-autocomplete v-model="selected_employee" v-if="!readonly" label="Selecione os funcionários para adicionar" prepend-icon="mdi-account" :filter="filter"
         :items="employees" item-text="attributes.name" item-value="id" :loading="loading.employees">
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="pb-1">
                <span v-if="item.attributes.id"> Nome:</span> 
                <b> {{item.attributes.name}} </b> 
              </v-list-item-title>
              <v-list-item-subtitle class="d-flex justify-space-between">
                <div>CPF: <b>{{ item.attributes.cpf }} </b> </div>
                <div>Cargos: <b>{{ item.attributes.roles_translated }}</b></div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-data-table :loading="loading.employees" :items="selected_employees" :headers="computed_headers">
          <template v-slot:item.actions="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="removeEmployee(item.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Retirar funcionário da carteira</span>
            </v-tooltip>    
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
import Api from '@/api/index';
import validations from '@/mixins/validations.js'

export default {
  name: 'ClientPortfolioSelectEmployees',
  mixins: [ validations ],
  props:{
    
    client_portfolio:{
      required: true,
      type: Object,
    },
    readonly:{
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      rules:[
        v => this.client_portfolio.employee_ids.length == 0 ? false : true || "Adicione pelo menos 1 funcionário."
      ],
      headers:[
        { text: 'Nome', value: 'attributes.name', align: 'center' },
        { text: 'CPF', value: 'attributes.cpf', align: 'center' },
        { text: 'Cargos', value: 'attributes.roles_translated', align: 'center' },
        
      ],
      employees: [],
      selected_employee: null,
      loading:{
        employees: false
      }
    }
  },
  computed:{
    computed_headers(){
      if(this.readonly){
        return this.headers
      }else{
        return [
          ...this.headers,
          { text: 'Ações', value: 'actions', align: 'center' },
        ]
      }
    },
    selected_employees(){
      return this.employees.filter(e => this.client_portfolio.employee_ids.includes(String(e.id)) || this.client_portfolio.employee_ids.includes(Number(e.id)))
    }
  },
  methods:{
    getData(){
      this.getEmployees()
    },
    getEmployees(){
      this.loading.employees = true
      Api.Employee.index().then(res => {
        this.employees = [...res.data.data]
      }).finally(()=>{
        this.loading.employees = false
      })
    },
    validate(){
      return this.$refs.form.validate()
    },
    removeEmployee(id){
      let idx = this.client_portfolio.employee_ids.indexOf(String(id))
      if(idx == -1){
        idx = this.client_portfolio.employee_ids.indexOf(Number(id))
      }
      this.client_portfolio.employee_ids.splice(idx, 1)
    },
    filter(item, queryText, itemText) {
      const name = item?.attributes.name ? item?.attributes.name.toLowerCase() : ''
      const cpf = item?.attributes.cpf ? item?.attributes.cpf.toLowerCase() : ''
      const roles_translated = item?.attributes.roles_translated ? item?.attributes.roles_translated.toLowerCase() : ''
      const id = item.id ? item.id.toString() : ''
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || cpf.indexOf(searchText) > -1 || id.indexOf(searchText) > -1 || roles_translated.indexOf(searchText) > -1
    },
  },
  watch:{
    selected_employee(nv){
      if(nv){
        if(!this.client_portfolio.employee_ids.includes(nv)){
          this.client_portfolio.employee_ids.push(nv)
        }
      }
    }
  },
  mounted(){
    this.getData()
  }
}
</script>
